import * as React from 'react'
import styles from './index.module.css'

type Props = {
  children: React.ReactNode
}

const BrowserFrame = (props: Props): React.ReactElement<'div'> => (
  <div className={styles.browserFrame}>
    <div className={styles.browserFrameBar} />
    {props.children}
  </div>
)

export default BrowserFrame
